import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import '../../assets/modal.css';
class PlanModal extends Component {
  constructor() {
    super();
    this.state = {
      popupOpen: false
    }
  }


  openPopup = () => {
    this.setState({
      popupOpen: true
    })
  }

  closePopup = () => {
    this.setState({
      popupOpen: false,
    })
  }







  render() {



    function Display(data) {
      let a = data;
      let b = data.data.data.respData;
      // console.log(b);
      let c;
      if (a.default) {
        c = b.default_number_count.map(item => (
          <div>
            <span>Number Cost: {item.number_cost}</span> || <span>Count: {item.count}</span>
          </div>
        ))
      }
      if (a.vip) {
        c = b.vip_number_count.map(item => (
          <div>
            <span>Number Cost: {item.number_cost}</span> || <span>Count: {item.count}</span>
          </div>
        ))
      }
      if (a.similar) {
        c = b.similar_number_count.map(item => (
          <div>
            <span>Number Cost: {item.number_cost}</span> || <span>Count: {item.count}</span>
          </div>
        ))
      }
      if (a.premium) {
        c = b.premium_number_count.map(item => (
          <div>
            <span>Number Cost: {item.number_cost}</span> || <span>Count: {item.count}</span>
          </div>
        ))
      }
      if (c.length == 0) return <div>None</div>
      return c;

    }



    let popper = <Popup open={this.state.popupOpen} closeOnDocumentClick={false} className="Modal">
      <div className="Modal" >

        <div style={{ 'textAlign': 'Left' }}>
          <h4>
            Date :{this.props.date}
          </h4>
          <div style={{ 'fontSize': '16px', 'fontWeight': 'bold' }}>Default</div>
          <Display default={true} data={this.props} />
          <div style={{ 'fontSize': '16px', 'fontWeight': 'bold' }}>Similar</div>
          <Display similar={true} data={this.props} />
          <div style={{ 'fontSize': '16px', 'fontWeight': 'bold' }}>Premium</div>
          <Display premium={true} data={this.props} />
          <div style={{ 'fontSize': '16px', 'fontWeight': 'bold' }}>VIP</div>
          <Display vip={true} data={this.props} />
          <div style={{ 'padding': 0, 'textAlign': 'center' }}>

            <button onClick={this.closePopup}>Back</button>
          </div>
        </div>
      </div>
    </Popup>


    return (
      <div>
        <h5 style={{ 'color': '#32abbc', 'cursor': 'pointer' }} onClick={this.openPopup}><strong>{this.props.date}</strong></h5>
        {popper}
      </div>
    )
  }
}

export default PlanModal;